var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "foodListWrap"
  }, [_vm.skuData.coupon_type === 'group' ? _c('div', {
    staticClass: "foodVoteList",
    class: _vm.themeClass
  }, [_c('div', {
    staticClass: "foodVoteList-item",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goPurchase();
      }
    }
  }, [_c('div', {
    class: {
      'foodVoteList-item-img': true,
      'irregularImg': _vm.isCar
    },
    style: {
      backgroundImage: `url(${_vm.skuData.pic_url})`
    }
  }), _c('div', {
    staticClass: "foodVoteList-item-info"
  }, [_vm.skuData.product_name ? _c('div', {
    staticClass: "poi-name",
    class: {
      'is-ios-title': _vm.isIPhone
    }
  }, [_vm._v(" " + _vm._s(_vm.skuData.product_name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "foodVoteList-info-wrap"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "poi-label-info"
  }, [_vm.skuData.tags_info && _vm.skuData.tags_info.length ? _vm._l(_vm.skuData.tags_info, function (item, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(item.name))]);
  }) : _vm._e()], 2), _vm.skuType ? _c('div', {
    staticClass: "poi-info-price"
  }, [_vm.skuData.sale_price_str ? _c('div', {
    class: {
      'price-num': true,
      'price-maxnum': _vm.skuType
    }
  }, [_vm._v(" " + _vm._s(_vm.skuData.sale_price_str) + " ")]) : _vm._e(), _vm.skuData.origin_price_str ? _c('div', {
    staticClass: "discount",
    style: _vm.isHouse ? 'text-decoration: none;' : ''
  }, [_vm._v(" " + _vm._s(_vm.skuData.origin_price_str) + " ")]) : _vm._e(), _vm.skuDiscount ? _c('div', {
    staticClass: "sku-label"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v(_vm._s(_vm.skuDiscount))]), _vm._v("折 ")]) : _vm._e()]) : _c('div', {
    staticClass: "poi-info-price"
  }, [_vm.specPrefix ? _c('div', {
    staticClass: "price-prefix"
  }, [_c('span', {
    staticClass: "price-prefix-text"
  }, [_vm._v("券后")])]) : _c('div', {
    staticClass: "price-prefix"
  }, [_vm._v("¥")]), _vm.realPrice ? _c('div', {
    staticClass: "price-num"
  }, [_vm._v(" " + _vm._s(_vm.realPrice) + " ")]) : _vm._e(), _vm.skuData.origin_price ? _c('div', {
    staticClass: "discount"
  }, [_vm._v(" ¥" + _vm._s(_vm.skuData.origin_price / 100) + " ")]) : _vm._e(), _vm.skuDiscount ? _c('div', {
    staticClass: "sku-label"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v(_vm._s(_vm.skuDiscount))]), _vm._v("折 ")]) : _vm._e()])]), _c('div', {
    staticClass: "content-list-right"
  }, [_c('div', {
    staticClass: "go-purchase",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goBtnPurchase();
      }
    }
  }, [_vm._v(_vm._s(_vm.skuData.button_text || '抢购'))])])])])]), _c('div', {
    staticClass: "foodVoteList-more",
    class: {
      'between': _vm.skuData.recommend_msg
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.purchaseMore.apply(null, arguments);
      }
    }
  }, [_vm.skuData.recommend_msg ? _c('div', {
    staticClass: "skuText"
  }, [_vm._v(_vm._s(_vm.skuData.recommend_msg))]) : _vm._e(), _c('div', {
    staticClass: "moreText"
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v(_vm._s(_vm.skuData.bottom_text || '查看全部优惠'))]), _c('div', {
    staticClass: "icon"
  })])])]) : _vm._e(), _vm.skuData.coupon_type === 'normal' ? _c('div', {
    staticClass: "foodCouponList",
    class: _vm.themeClass
  }, [_c('div', {
    staticClass: "foodCouponList-wrap"
  }, [_c('img', {
    staticClass: "foodCouponList-bg",
    attrs: {
      "src": _vm.foodCouponBg,
      "alt": ""
    }
  }), _c('div', {
    staticClass: "foodCouponList-item",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goPurchase();
      }
    }
  }, [_c('div', {
    staticClass: "foodCouponList-item-info"
  }, [_c('div', {
    staticClass: "foodCouponList-info-wrap"
  }, [_vm.skuData.product_name ? _c('div', {
    staticClass: "poi-name",
    class: {
      'is-ios-title': _vm.isIPhone
    }
  }, [_vm._v(" " + _vm._s(_vm.skuData.product_name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "poi-label-info"
  }, [_vm.skuData.app_name ? _c('span', [_vm._v(_vm._s(_vm.skuData.app_name))]) : _vm._e(), _vm.skuData.buy_rule && _vm.skuData.buy_rule.usetime_time_str ? _c('span', [_vm._v(" " + _vm._s(_vm.skuData.buy_rule.usetime_time_str))]) : _vm._e()]), _c('div', {
    staticClass: "poi-info-price"
  }, [_vm.specPrefix ? _c('div', {
    staticClass: "price-prefix"
  }, [_c('span', {
    staticClass: "price-prefix-text"
  }, [_vm._v("券后")])]) : _c('div', {
    staticClass: "price-prefix"
  }, [_vm._v("¥")]), _vm.realPrice ? _c('div', {
    staticClass: "price-num"
  }, [_vm._v(" " + _vm._s(_vm.realPrice) + " ")]) : _vm._e(), _vm.skuData.origin_price ? _c('div', {
    staticClass: "discount"
  }, [_vm._v(" ¥" + _vm._s(_vm.skuData.origin_price / 100) + " ")]) : _vm._e(), _vm.skuDiscount ? _c('div', {
    staticClass: "sku-label"
  }, [_c('span', {
    staticClass: "spa"
  }, [_vm._v(_vm._s(_vm.skuDiscount))]), _vm._v("折 ")]) : _vm._e()])])]), _c('div', {
    staticClass: "content-list-right"
  }, [_c('div', {
    staticClass: "go-purchase",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.goBtnPurchase();
      }
    }
  }, [_vm._v("抢购")])])])]), _c('div', {
    staticClass: "foodCouponList-more",
    class: {
      'between': _vm.skuData.recommend_msg
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.purchaseMore.apply(null, arguments);
      }
    }
  }, [_vm.skuData.recommend_msg ? _c('div', {
    staticClass: "skuText"
  }, [_vm._v(_vm._s(_vm.skuData.recommend_msg))]) : _vm._e(), _vm._m(0)])]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "moreText"
  }, [_c('span', {
    staticClass: "span"
  }, [_vm._v("查看全部优惠")]), _c('div', {
    staticClass: "icon"
  })]);
}];
export { render, staticRenderFns };